import React, { useEffect, useRef } from 'react';
import anime from 'animejs';
import { usePlatformStore } from '../stores/platformStore';

export function SplashScreen() {
    const part1Ref = useRef<SVGPolygonElement>(null);
    const part2Ref = useRef<SVGPolygonElement>(null);
    const part3Ref = useRef<SVGPolygonElement>(null);
    const part4Ref = useRef<SVGPolygonElement>(null);
    const part5Ref = useRef<SVGPolygonElement>(null);
    const part6Ref = useRef<SVGPathElement>(null);
    const part7Ref = useRef<SVGPolygonElement>(null);
    const part8Ref = useRef<SVGPolygonElement>(null);
    const part9Ref = useRef<SVGPolygonElement>(null);

    const isConnecting = usePlatformStore((s) => s.isConnectingToBackend);

    const getConnectionStatus = (): string => {
        if (isConnecting) {
            return 'Connecting to backend service...';
        }
        return 'Starting application...';
    };

    useEffect(() => {
        const targets = [
            part1Ref.current,
            part2Ref.current,
            part3Ref.current,
            part4Ref.current,
            part5Ref.current,
            part6Ref.current,
            part7Ref.current,
            part8Ref.current,
            part9Ref.current,
        ].filter(Boolean);

        anime({
            targets,
            translateY: [50, 0],
            opacity: [0, 1],
            duration: 1000,
            easing: 'easeOutExpo',
            delay: anime.stagger(100),
        });
    }, []);

    return (
        <div className="fixed top-0 left-0 w-full h-full bg-neutral-600 flex flex-col items-center justify-center text-neutral-200 font-primary z-[10000]">
            <svg
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1080 896.55"
                className="w-[150px] h-[150px] mb-lg"
            >
                <defs>
                    <style>
                        {`
                            .cls-1 { fill: #ce0d0d; }
                            .cls-2 { fill: #e9222c; }
                            .cls-3 { fill: #ed2827; }
                        `}
                    </style>
                </defs>
                <polygon ref={part1Ref} className="cls-3" points="212.58 341.99 0 554.57 313.26 554.57 212.58 341.99" />
                <polygon ref={part2Ref} className="cls-1" points="525.84 341.99 212.58 341.99 313.26 554.57 525.84 341.99" />
                <polygon ref={part3Ref} className="cls-3" points="0 896.55 313.26 896.55 212.58 683.97 0 896.55" />
                <polygon ref={part4Ref} className="cls-1" points="313.26 896.55 525.84 683.97 212.58 683.97 313.26 896.55" />
                <polygon ref={part5Ref} className="cls-3" points="908.27 681.7 506.05 554.67 779.29 896.55 1080 896.55 908.27 681.7" />
                <path ref={part6Ref} className="cls-3" d="M313.26,212.58L525.84,0h269.09c41.12,0,79.75,10.6,113.34,29.19,25.81,14.28,48.65,33.27,67.34,55.82,29.28,35.35,48.41,79.27,52.82,127.6.75,7.24,1.08,14.56,1.08,21.96,0,64.8-26.29,123.36-68.71,165.87l-52.16,52.16-101.96,101.98.07.08-300.52-.05-.19.05,304.45-304.54c3.91-3.99,6.41-9.48,6.41-15.55,0-12.15-9.82-21.96-21.96-21.96l-481.67-.04Z" />
                <polygon ref={part7Ref} className="cls-1" points="806.74 554.67 506.05 554.67 908.27 681.7 806.74 554.67" />
                <polygon ref={part8Ref} className="cls-2" points="212.56 0 96.27 116.3 .02 212.59 313.24 212.59 212.56 0" />
                <polygon ref={part9Ref} className="cls-1" points="525.84 0 212.58 0 313.26 212.59 525.84 0" />
            </svg>

            <div className='flex text-center'>
                <div className='flex flex-col items-center justify-center max-w-lg mx-4'>
                    <div className="bg-gradient-to-br from-neutral-700/30 to-neutral-800/30 border border-neutral-600/30 rounded-xl p-8 shadow-lg backdrop-blur-sm">
                        <div className="flex justify-center mb-4">
                            <div className="w-10 h-10 border-4 border-neutral-400/30 border-t-red-500 rounded-full animate-spin" />
                        </div>
                        <div className="text-center">
                            <p className="text-sm font-medium text-neutral-200 mb-1">
                                {getConnectionStatus()}
                            </p>
                            <div className="flex items-center justify-center space-x-1 text-xs text-neutral-400">
                                <div className="w-1 h-1 bg-neutral-400 rounded-full animate-pulse" />
                                <div className="w-1 h-1 bg-neutral-400 rounded-full animate-pulse" style={{animationDelay: '0.2s'}} />
                                <div className="w-1 h-1 bg-neutral-400 rounded-full animate-pulse" style={{animationDelay: '0.4s'}} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
